var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"avatarUrl"},[_c('img',{attrs:{"src":_vm.userInfo.avatarUrl,"alt":"图片"},on:{"click":function($event){return _vm.skip('/uploadAvatar')}}}),_vm._v(" "),_c('div',{on:{"click":function($event){return _vm.skip('/uploadAvatar')}}},[_vm._v("Upload avatar")])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-24fad988","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/mycom/avatarUrl.vue
// module id = null
// module chunks = 